// Recidiviz - a data platform for criminal justice reform
// Copyright (C) 2024 Recidiviz, Inc.
//
// This program is free software: you can redistribute it and/or modify
// it under the terms of the GNU General Public License as published by
// the Free Software Foundation, either version 3 of the License, or
// (at your option) any later version.
//
// This program is distributed in the hope that it will be useful,
// but WITHOUT ANY WARRANTY; without even the implied warranty of
// MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
// GNU General Public License for more details.
//
// You should have received a copy of the GNU General Public License
// along with this program.  If not, see <https://www.gnu.org/licenses/>.
// =============================================================================

export const palette = {
  solid: {
    red: `rgba(221, 18, 18, 1)`,
    orange: `rgba(255, 128, 0, 1)`,
    green: `rgba(0, 117, 64, 1)`,
    lightgreen: `rgba(239, 244, 245, 1)`,
    blue: `rgba(0, 115, 229, 1)`,
    darkblue: `rgba(0, 86, 224, 1)`,
    darkblue2: `rgba(19, 49, 88, 1)`,
    grey1: `rgba(119, 119, 119, 1)`,
    grey2: `rgb(222, 222, 222)`, // solid color version of `highlight.grey3`
    darkgrey: `rgba(0, 17, 51, 1)`,
    lightgrey: `rgb(217, 219, 224)`,
    lightgrey2: `rgba(248, 248, 248, 1)`,
    lightgrey3: `rgba(220, 220, 220, 1)`,
    lightgrey4: `rgba(236, 236, 236, 1)`,
    lightgrey5: `rgba(235, 235, 235, 1)`,
    white: `rgba(255,255,255, 1)`,
    offwhite: `rgba(239, 244, 245, 1)`,
    offwhitenoir: `rgba(239, 244, 245, 1)`,
    black: `rgba(14, 17, 26, 1)`,
  },
  highlight: {
    red: `rgba(221, 18, 18, 0.05)`,
    darkred: `rgba(221, 18, 18, 0.3)`,
    blue: `rgba(0, 115, 229, 0.1)`,
    green: `rgba(0, 117, 65, 0.1)`,
    darkgreen: `rgba(0, 117, 65, 0.3)`,
    lightblue1: `rgba(0, 115, 229, 0.05)`,
    lightblue2: `rgba(0, 115, 229, 0.25)`,
    lightgrey1: `rgba(190, 190, 190, 0.1)`,
    grey1: `rgba(0, 17, 51, 0.05)`,
    grey2: `rgba(0, 17, 51, 0.1)`,
    grey3: `rgba(0, 17, 51, 0.15)`,
    grey4: `rgba(0, 17, 51, 0.2)`,
    grey5: `rgba(0, 17, 51, 0.25)`,
    grey6: `rgba(0, 17, 51, 0.3)`,
    grey7: `rgba(0, 17, 51, 0.4)`,
    grey8: `rgba(0, 17, 51, 0.5)`,
    grey9: `rgba(0, 17, 51, 0.6)`,
    grey10: `rgba(0, 17, 51, 0.7)`,
    grey11: `rgba(0, 17, 51, 0.8)`,
    grey12: `rgba(0, 17, 51, 0.9)`,
    white1: `rgba(255,255,255, 0.2)`,
    white2: `rgba(255,255,255, 0.5)`,
  },
  gradient: {
    lightgreen: `linear-gradient(90deg,rgba(184,255,184,.3) 0%,rgba(170,232,170,.2) 35%,rgba(216,254,216,.3) 100%)`,
    lightred: `linear-gradient(90deg,rgba(255,184,184,.3) 0%,rgba(232,170,170,.2) 35%,rgba(254,216,216,.3) 100%)`,
  },
  dataViz: {
    bar1: "#133158",
    bar2: "#5C8970",
    bar3: "#D4A244",
    bar4: "#6E4245",
    bar5: "#BD484A",
    bar6: "#353A6E",
    bar7: "#BA845F",
    bar8: "#64859E",
    bar9: "#596041",
    bar10: "#C36C3B",
    bar11: "#081E5C",
  },
};
